import React from "react";
import { renderToString } from "react-dom/server";
import Icon from "./Icon";

function render(text: string, color: string) {
  return renderToString(<Icon text={text} color={color} />);
}

export default {
  c: render("c", "rgb(216, 141, 19)"),
  u: render("u", "rgb(59, 128, 208)"),
  e: render("e", "rgb(195, 12, 65)")
};
